module.exports = "https://cdn-assessment.mathletics.com/app/113/assets/images/4d6060a16f3cff38af9244009d590660.svg";